import { render, staticRenderFns } from "./liveBJY.vue?vue&type=template&id=4f70e3d2&"
import script from "./liveBJY.vue?vue&type=script&lang=js&"
export * from "./liveBJY.vue?vue&type=script&lang=js&"
import style0 from "./liveBJY.vue?vue&type=style&index=0&id=4f70e3d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports